import React from 'react'
import cx from 'classnames'
import './Typography.scss'

const Heading2 = ({ children, white, purple, center, bottomSpace, className }) => (
    <h2 className={cx('heading2', className, white ? 'heading-white' : '', purple ? 'heading-purple' : '', center ? 'text-center' : '', bottomSpace ? 'bottom-space' : '')}>{children}</h2>
)

export default Heading2



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/typography/Heading2.jsx